import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './BusinessInformationComponent.metadata.json5';
import SubsidiaryInformationComponent from '../subcomponents/SubsidiaryInformation/SubsidiaryInformationComponent';
import EmployeesAndVolunteersComponent from '../subcomponents/EmployeesAndVolunteers/EmployeesAndVolunteersComponent'
import ProfessionalsWorksAppBusinessComponent from '../subcomponents/ProfessionalsWorksAppBusinessComponent/ProfessionalsWorksAppBusinessComponent';

import styles from '../MedicalPractitioners.module.scss';

function BusinessInformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('BusinessInformationComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    const calculateTotalEmpQuantity = () => {
        let totalEmployees = 0;

        if (!_.isUndefined(modelVM.value.numOfFulTimEmp20)) {
            totalEmployees += modelVM.value.numOfFulTimEmp20
        }

        if (!_.isUndefined(modelVM.value.numOfParTimEmp21)) {
            totalEmployees += modelVM.value.numOfParTimEmp21
        }

        modelVM.value.totEmpQua22 = totalEmployees;

        return totalEmployees;
    }


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        inWhaCapIsTheAppAnd13: {
            visible: !_.isUndefined(modelVM.value.areAnyOfThePraCurEnr12) && modelVM.value.areAnyOfThePraCurEnr12
        },
        whaTypOfOpeOrSerAre14: {
            visible: !_.isUndefined(modelVM.value.areAnyOfThePraCurEnr12) && modelVM.value.areAnyOfThePraCurEnr12
        },
        ifNoPleExp16: {
            visible: !_.isUndefined(modelVM.value.areAllEmpCovByProWor15) && !modelVM.value.areAllEmpCovByProWor15
        },
        ifNoPleExp18: {
            visible: !_.isUndefined(modelVM.value.doAllEmpCarAValLic17) && !modelVM.value.doAllEmpCarAValLic17
        },
        totEmpQua22: {
            value: calculateTotalEmpQuantity(),
            disabled: true
        },
        numOfFulTimEmp20: {
            defaultValue: 1
        },
        numOfParTimEmp21: {
            defaultValue: 0
        },
        numOfOrt26: {
            defaultValue: 0
        },
        numOfAne27: {
            defaultValue: 0
        },
        numOfGyn28: {
            defaultValue: 0
        },
        numOfUro29: {
            defaultValue: 0
        },
        numOfGenPra30: {
            defaultValue: 0
        },
        subsidiaryInformationComponent: {
            data: modelVM.subsidiaryInformationDTO,
            updateWizardData,
            submissionVM,
            SubsidiaryInformationPath: `${pathUpdated}.subsidiaryInformationDTO`
        },
        employeesAndVolunteersComponent: {
            data: modelVM.employeesAndVolunteersDTO,
            updateWizardData,
            submissionVM,
            EmployeesandVolunteersPath: `${pathUpdated}.employeesAndVolunteersDTO`
        },
        professionalsWorksAppBusinessComponent: {
            data: modelVM.professionalsWorksAppBusinessDTO,
            updateWizardData,
            submissionVM,
            ProfessionalsWorksAppBusinessComponentPath: `${pathUpdated}.professionalsWorksAppBusinessDTO`
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            subsidiaryInformationComponent: SubsidiaryInformationComponent,
            employeesAndVolunteersComponent: EmployeesAndVolunteersComponent,
            professionalsWorksAppBusinessComponent: ProfessionalsWorksAppBusinessComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

BusinessInformationComponent.propTypes = wizardProps;
export default withRouter(BusinessInformationComponent);
